angular
    .module('rischioInCorso.components', ['app.services'])
    .component('rischioInCorso', {
        templateUrl: 'ng/components/rischioInCorso/rischioInCorso.view.html',
        controllerAs: 'RischioInCorsoCtrl',
        bindings: {
            //oggetto del componente che prende i dati delle pratiche cliente
            configObjPraticheCliente: '=',
            //oggetto del componente che prende i dati delle pratiche gruppo
            configObjPraticheGruppo: '=',
            //oggetto del componente che prende il totale pratiche
            configObjTotalePratiche: '=',
            // valore per il recupero dei dati
            partitaIva: '<',
            //controllo loading
            loading: '=',

            praticheOk: '&?'
        },
        controller: function ($scope, HttpService, $sessionStorage, $rootScope, $location, validationService, $searchUserService, $simulationService, FactoryObj, $filter, $translate, es6Factory, $monitoringService, $featureService, $financialService) {
            var self = this;
            self.$onInit = function () {
                self.configObjPraticheCliente = self.configObjPraticheCliente || null;
                self.partitaIva = self.partitaIva || '09435590154';
                self.loading = true;
                $financialService.getRischioInCorso(self.partitaIva)
                    .then(function (res) {
                        if (res.dloGetRischioInCorsoOutput) {
                            var cliente = res.dloGetRischioInCorsoOutput.cliente;
                            var gruppo = res.dloGetRischioInCorsoOutput.gruppo;
                            var tot = res.dloGetRischioInCorsoOutput.totale;
                            self.configObjPraticheCliente = {
                                titolo: 'PRATICHE CLIENTE',
                                preventiviAccettati: cliente.prevAccettati.numero,
                                importoPreventiviAccettati: cliente.prevAccettati.importo,
                                contrattiPervenutiAttivi: cliente.ctrAttivi.numero,
                                contrattiStipulati: cliente.ctrStipulati.numero,
                                contrattiTotali: cliente.totale.numero,
                                importoContrattiPervenutiAttivi: cliente.ctrAttivi.importo,
                                importoContrattiStipulati: cliente.ctrStipulati.importo,
                                importoContrattiTotali: cliente.totale.importo
                            };
                            self.configObjPraticheGruppo = {
                                titolo: 'PRATICHE GRUPPO',
                                preventiviAccettati: gruppo.prevAccettati.numero,
                                importoPreventiviAccettati: gruppo.prevAccettati.importo,
                                contrattiPervenutiAttivi: gruppo.ctrAttivi.numero,
                                contrattiStipulati: gruppo.ctrStipulati.numero,
                                contrattiTotali: gruppo.totale.numero,
                                importoContrattiPervenutiAttivi: gruppo.ctrAttivi.importo,
                                importoContrattiStipulati: gruppo.ctrStipulati.importo,
                                importoContrattiTotali: gruppo.totale.importo
                            };
                            self.configObjTotalePratiche = {
                                totalePratiche: tot.totale.numero,
                                importoTotalePratiche: tot.totale.importo
                            };
                        }

                    }).catch(function (data) {
                        $rootScope.$broadcast("addAlert", {
                            text: 'ERROR_NEXT'
                        });
                    }).finally(function () {
                        self.loading = false;
                        self.praticheOk();
                    });
            };

        }
    });